// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3a4k5","notes":"Notes_notes__PX_ZE","note":"Notes_note__1g-Dw","markdown":"Notes_markdown__3MLbC"};